export const paymentSuccessHeader = 'Your order is successfully placed';
export const weAreBetterOnApp = 'We are better on the app!';
export const downloadNow = 'Download now';
export const successImgUrl =
  'https://dom-content-vault-prod-cdn-assets.porter.in/order_success_emphasis_b7e96603b9/order_success_emphasis_b7e96603b9.svg';
export const orderDetailsImgUrl =
  'https://dom-content-vault-prod-cdn-assets.porter.in/order_details_placeholder_06072b6431/order_details_placeholder_06072b6431.png';
export const paymentSuccessIconAlt = 'payment success icon';
export const orderDetailsIconAlt = 'order details icon';
